{
  "_vgBinding": "vg-binding: CONTEXT:decisions=P17.D-25,P17.D-26,P17.D-33,P17.D-41,P17.D-42,P17.D-45,P17.D-47 INTERFACE-STANDARDS:error-shape — complete vendorRouting namespace (page shell + 4 tabs + dialogs + fence report + typed error codes keyed by error.code) owned by task-28; waves 9-11 consume t() only [task-28]",
  "nav": {
    "routing": "Định tuyến"
  },
  "page": {
    "title": "Định tuyến nhà cung cấp",
    "subtitle": "Trọng số chấm điểm, luật riêng của merchant, thứ tự ưu tiên theo blueprint và báo cáo hàng rào vị trí.",
    "placeholder": {
      "weights": "Trọng số chấm điểm chưa hiển thị được trên màn hình này.",
      "merchantRules": "Luật định tuyến của merchant chưa hiển thị được trên màn hình này.",
      "preferences": "Thứ tự ưu tiên định tuyến theo blueprint chưa hiển thị được trên màn hình này.",
      "fenceReport": "Báo cáo hàng rào vị trí chưa hiển thị được trên màn hình này."
    }
  },
  "tabs": {
    "weights": "Trọng số",
    "merchantRules": "Luật merchant",
    "preferences": "Thứ tự ưu tiên",
    "fenceReport": "Báo cáo hàng rào"
  },
  "forbidden": {
    "title": "Không có quyền truy cập",
    "description": "Bạn cần quyền quản lý luật gán đơn mới mở được trang định tuyến nhà cung cấp. Hãy đề nghị quản trị viên cấp quyền.",
    "home": "Về trang chủ"
  },
  "common": {
    "retry": "Thử lại",
    "cancel": "Huỷ",
    "save": "Lưu",
    "close": "Đóng",
    "loading": "Đang tải…",
    "na": "N/A"
  },
  "weights": {
    "live": {
      "heading": "Trọng số đang chạy",
      "versionLabel": "Phiên bản {{version}}",
      "configSource": {
        "document": "Lấy từ cấu hình đã lưu",
        "fallback_default": "Lấy từ giá trị mặc định đi kèm bản build"
      }
    },
    "fallbackDefault": "Không tìm thấy cấu hình đã lưu nên engine đang chạy bằng giá trị mặc định đi kèm bản build. Định tuyến vẫn hoạt động bình thường; hãy đề xuất một bộ trọng số để thay thế.",
    "axis": {
      "rating": "Điểm đánh giá",
      "utilization": "Mức tải",
      "sla": "SLA",
      "cost": "Chi phí",
      "preferenceEpsilon": "Ngưỡng gom nhóm ưu tiên"
    },
    "costShadowNote": "Trục chi phí để 0 là cố ý: điểm vẫn được tính và ghi lại, nhưng chưa làm đổi lựa chọn nào cho tới khi có đề xuất nâng trọng số.",
    "epsilonHint": "Ship ở mức 0 nên chỉ những vendor có điểm bằng nhau tuyệt đối mới được gom chung nhóm. Nâng lên nếu muốn các điểm xấp xỉ nhau cũng vào chung nhóm trước khi áp thứ tự ưu tiên.",
    "pending": {
      "heading": "Đề xuất đang chờ",
      "proposedBy": "Người đề xuất",
      "proposedAt": "Thời điểm đề xuất",
      "reason": "Lý do",
      "diffLive": "Đang chạy",
      "diffProposed": "Đề xuất"
    },
    "pendingBlocksPropose": "Đã có một đề xuất đang chờ quyết định. Mỗi lần chỉ mở được một đề xuất — hãy duyệt, từ chối hoặc huỷ nó trước.",
    "selfApprovalDisabled": "Bạn là người đề xuất bộ trọng số này nên cần một quản trị viên khác duyệt.",
    "cancelOwnerOnly": "Chỉ quản trị viên đã đề xuất mới huỷ được đề xuất đó.",
    "propose": {
      "heading": "Đề xuất bộ trọng số mới",
      "sumLabel": "Tổng bốn trục",
      "epsilonLabel": "Ngưỡng gom nhóm ưu tiên (không tính vào tổng)",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Vì sao cần đổi bộ trọng số này?",
      "submit": "Gửi đề xuất"
    },
    "actions": {
      "approve": "Duyệt",
      "reject": "Từ chối",
      "cancel": "Huỷ đề xuất",
      "revert": "Khôi phục bộ này"
    },
    "revert": {
      "reasonPrefill": "Khôi phục bộ trọng số đã chạy trước phiên bản {{version}}."
    },
    "approve": {
      "title": "Duyệt bộ trọng số này?",
      "noteLabel": "Ghi chú (không bắt buộc)",
      "confirm": "Duyệt và kích hoạt"
    },
    "reject": {
      "title": "Từ chối đề xuất này",
      "reasonLabel": "Lý do",
      "reasonRequired": "Bắt buộc nhập lý do — đây là bằng chứng vì sao thay đổi bị từ chối.",
      "reasonPlaceholder": "Nêu rõ bộ trọng số được đề xuất sai ở chỗ nào.",
      "confirm": "Từ chối đề xuất"
    },
    "cancel": {
      "title": "Huỷ đề xuất của bạn",
      "noteLabel": "Ghi chú (không bắt buộc)",
      "confirm": "Huỷ đề xuất"
    },
    "history": {
      "heading": "Lịch sử kích hoạt",
      "empty": "Chưa có bộ trọng số nào được kích hoạt. Engine đang chạy bằng bộ đang hiển thị ở trên.",
      "version": "Phiên bản",
      "activatedAt": "Kích hoạt lúc",
      "activatedBy": "Người kích hoạt",
      "proposedBy": "Người đề xuất"
    },
    "toast": {
      "proposed": "Đã gửi đề xuất. Đang chờ một quản trị viên khác quyết định.",
      "approved": "Đã duyệt, bộ trọng số mới bắt đầu chạy.",
      "rejected": "Đã từ chối đề xuất. Bộ trọng số đang chạy giữ nguyên.",
      "cancelled": "Đã huỷ đề xuất. Bộ trọng số đang chạy giữ nguyên."
    },
    "unknownAdmin": "Admin không còn tồn tại"
  },
  "rules": {
    "heading": "Luật định tuyến theo merchant",
    "table": {
      "merchant": "Merchant",
      "blockedCount": "Chặn",
      "allowedCount": "Cho phép",
      "updatedAt": "Cập nhật lúc",
      "updatedBy": "Người cập nhật",
      "actions": "Thao tác"
    },
    "filters": {
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "Tên hoặc id merchant",
      "sortLabel": "Sắp xếp theo"
    },
    "sort": {
      "updatedAtDesc": "Cập nhật mới nhất trước",
      "updatedAtAsc": "Cập nhật cũ nhất trước",
      "merchantNameAsc": "Tên merchant A→Z",
      "merchantNameDesc": "Tên merchant Z→A"
    },
    "empty": {
      "title": "Chưa merchant nào có luật định tuyến",
      "description": "Danh sách này chỉ hiển thị merchant đã có bản ghi luật. Không có gì hỏng — hãy chọn một merchant để tạo bộ luật đầu tiên."
    },
    "actions": {
      "add": "Thêm luật",
      "edit": "Sửa",
      "save": "Lưu luật",
      "removeVendor": "Bỏ vendor"
    },
    "editor": {
      "title": "Luật định tuyến",
      "blockedLabel": "Vendor bị chặn",
      "allowedLabel": "Vendor được phép",
      "vendorPickerPlaceholder": "Tìm vendor để thêm",
      "merchantPickerLabel": "Merchant"
    },
    "badge": {
      "inactive": "Ngừng hoạt động",
      "missing": "Không còn tồn tại"
    },
    "semantics": {
      "blockWins": "Vendor đã bị chặn thì vẫn bị chặn, kể cả khi cũng nằm trong danh sách cho phép.",
      "allowNarrows": "Danh sách cho phép khác rỗng sẽ thu hẹp định tuyến đúng vào những vendor đó — phần còn lại bị loại.",
      "emptyPoolManual": "Nếu bộ luật này làm rỗng danh sách vendor, item sẽ được giữ lại để gán tay thay vì rơi vào một vendor ngoài ý muốn."
    },
    "conflict": {
      "heading": "Có người khác lưu trước",
      "body": "Chỉnh sửa của bạn vẫn còn nguyên và chưa có gì được ghi. Hãy chọn: áp chỉnh sửa của bạn lên phiên bản mới hơn, hoặc bỏ chúng và bắt đầu lại từ bản đang lưu.",
      "unreadable": "Máy chủ không đọc được chính bản ghi rule đang lưu của merchant này, nên không hiển thị danh sách hiện tại. Lưu tiếp sẽ ghi đè bản ghi đó — hỏi người sửa gần nhất trước khi làm.",
      "retry": "Giữ chỉnh sửa của tôi và lưu lại",
      "discard": "Bỏ chỉnh sửa của tôi, tải bản mới",
      "changedBy": "Người thay đổi",
      "changedAt": "Thời điểm thay đổi"
    },
    "toast": {
      "saved": "Đã lưu luật định tuyến."
    }
  },
  "preferences": {
    "heading": "Thứ tự ưu tiên định tuyến theo blueprint",
    "blueprintLabel": "Blueprint",
    "pickBlueprint": "Chọn một blueprint để xem và sửa thứ tự vendor của nó.",
    "default": {
      "heading": "Mặc định của blueprint"
    },
    "overrides": {
      "heading": "Ghi đè theo variant"
    },
    "table": {
      "rank": "Thứ hạng",
      "vendor": "Vendor",
      "actions": "Thao tác"
    },
    "actions": {
      "moveUp": "Đưa lên",
      "moveDown": "Đưa xuống",
      "remove": "Bỏ khỏi thứ tự",
      "addOverride": "Thêm ghi đè cho variant",
      "removeOverride": "Xoá ghi đè này",
      "save": "Lưu thứ tự ưu tiên"
    },
    "empty": {
      "title": "Chưa đặt thứ tự ưu tiên",
      "description": "Không có gì sai: khi chưa có thứ tự, blueprint này định tuyến hoàn toàn theo điểm số."
    },
    "clearedToScoreOrder": "Đã lưu. Blueprint này không còn thứ tự ưu tiên nào, định tuyến quay lại chạy hoàn toàn theo điểm số.",
    "limits": {
      "afterFilters": "Thứ tự ưu tiên chỉ áp dụng sau khi các bước sau đã chạy: {{steps}}.",
      "topScoreGroupOnly": "Chúng chỉ sắp xếp lại các vendor trong nhóm điểm cao nhất — không bao giờ đẩy vendor điểm thấp lên trên vendor điểm cao.",
      "neverAllocation": "Chúng không bao giờ đụng tới tỷ lệ phân bổ: split giữ đúng phần trăm mà quản trị viên đã nhập."
    },
    "stage": {
      "merchant_rules": "Luật merchant",
      "location_fence": "Hàng rào vị trí",
      "rejected": "Vendor đã từ chối",
      "hard_filter": "Bộ lọc bắt buộc",
      "scoring": "Chấm điểm"
    },
    "override": {
      "title": "Thêm ghi đè cho variant",
      "variantLabel": "Variant",
      "allTaken": "Mọi variant của blueprint này đều đã có ghi đè.",
      "removeConfirm": "Xoá ghi đè của {{variant}}? Variant sẽ quay về dùng mặc định của blueprint."
    },
    "badge": {
      "inactive": "Ngừng hoạt động",
      "missing": "Không còn tồn tại",
      "variantMissing": "Variant không còn tồn tại"
    },
    "duplicateVendor": "Vendor này đã có trong thứ tự. Mỗi vendor chỉ được xuất hiện một lần.",
    "conflict": {
      "heading": "Có người khác lưu trước",
      "body": "Chưa có gì được ghi — thao tác lưu là tất-cả-hoặc-không, nên chỉ cần một phần lỗi thời là cả lượt lưu dừng lại. Chỉnh sửa của bạn vẫn còn nguyên.",
      "retry": "Giữ chỉnh sửa của tôi và lưu lại",
      "discard": "Bỏ chỉnh sửa của tôi, tải bản mới"
    },
    "toast": {
      "saved": "Đã lưu thứ tự ưu tiên."
    }
  },
  "fence": {
    "heading": "Báo cáo hàng rào vị trí",
    "mode": {
      "label": "Chế độ hàng rào",
      "workerReported": "Do worker định tuyến báo về",
      "heartbeatAt": "Tín hiệu gần nhất",
      "gitSha": "Bản build",
      "pid": "PID tiến trình",
      "staleWarning": "Worker chưa báo về gần đây nên chế độ hiển thị ở trên có thể đã cũ.",
      "neverReported": "Chưa worker nào từng báo về chế độ hàng rào nên không biết chế độ thật là gì. Màn hình này không đoán.",
      "off": "Tắt",
      "log": "Chỉ ghi log",
      "enforce": "Đang áp dụng",
      "unknown": "Chưa rõ"
    },
    "filters": {
      "fromLabel": "Từ",
      "toLabel": "Đến",
      "locationLabel": "Vị trí",
      "allLocations": "Tất cả vị trí",
      "blueprintLabel": "Blueprint",
      "allBlueprints": "Tất cả blueprint"
    },
    "coveredRange": {
      "label": "Khoảng thời gian có dữ liệu",
      "truncated": "Event chỉ được giữ {{ttlDays}} ngày nên phần đầu khoảng bạn chọn đã hết hạn."
    },
    "summary": {
      "totalEvents": "Số event hàng rào",
      "topScoreChanged": "Lựa chọn đầu bảng đổi",
      "distinctOrders": "Đơn bị ảnh hưởng",
      "distinctVariants": "Variant bị ảnh hưởng",
      "distinctLocations": "Vị trí bị ảnh hưởng",
      "topExcludedVendors": "Vendor bị loại nhiều nhất"
    },
    "table": {
      "heading": "Event hàng rào",
      "occurredAt": "Xảy ra lúc",
      "location": "Vị trí",
      "blueprintVariant": "Blueprint / variant",
      "order": "Đơn hàng",
      "excludedVendors": "Vendor bị loại",
      "poolBefore": "Pool trước",
      "poolAfter": "Pool sau",
      "poolDiffHint": "Hai con số này là số vendor đủ điều kiện, không phải số vendor được chọn.",
      "topScoreChanged": "Lựa chọn đầu bảng đổi"
    },
    "empty": {
      "modeOff": "Hàng rào đang tắt nên ở đây không có event nào là đúng.",
      "logNoEvents": "Hàng rào vẫn đang chạy và không tìm thấy gì phải thay đổi trong khoảng này."
    },
    "drift": {
      "heading": "Phân bổ nằm ngoài ràng buộc",
      "explain": "Những split này đẩy việc sang vendor mà ràng buộc vị trí không bao gồm. Màn hình này không tự sửa gì — hãy sửa ở nơi chỉnh phân bổ.",
      "openAllocations": "Mở trang phân bổ vendor",
      "table": {
        "variant": "Variant",
        "location": "Vị trí",
        "vendor": "Vendor",
        "weightPct": "Tỷ lệ",
        "enabled": "Đang bật",
        "reason": "Vấn đề"
      },
      "reason": {
        "VENDOR_NOT_IN_BINDING": "Vị trí này có ràng buộc nhưng không bao gồm vendor đó — hãy sửa phân bổ, hoặc mở rộng ràng buộc.",
        "NO_BINDING_FOR_LOCATION": "Variant chưa ràng buộc gì ở vị trí này — hãy tạo ràng buộc."
      },
      "empty": "Không có phân bổ nào nằm ngoài ràng buộc."
    },
    "ruleViolating": {
      "heading": "Đơn đã gán mà luật hiện tại sẽ từ chối",
      "explain": "Đổi luật không bao giờ tự định tuyến lại việc đã gán. Danh sách này chỉ để tham khảo: không có gì bị chuyển tự động, mọi điều chỉnh đều do người quyết định.",
      "empty": "Không có việc đang chạy nào trái với luật hiện hành.",
      "assignedAt": "Gán lúc",
      "ruleUpdatedAt": "Luật đổi lúc",
      "table": {
        "order": "Đơn hàng",
        "merchant": "Merchant",
        "variant": "Variant",
        "vendor": "Vendor",
        "violation": "Vì sao sẽ bị từ chối"
      },
      "violation": {
        "MERCHANT_BLOCKED": "Merchant hiện đã chặn vendor này.",
        "NOT_IN_ALLOWLIST": "Danh sách cho phép của merchant không còn vendor này.",
        "OUTSIDE_LOCATION_BINDING": "Ràng buộc vị trí không còn bao gồm vendor này."
      }
    },
    "priceSkew": {
      "heading": "Nhóm split có chênh lệch chi phí lớn",
      "explain": "Engine tôn trọng đúng tỷ lệ bạn nhập, bất kể giá bao nhiêu. Danh sách này chỉ cho thấy chỗ nào split đang tốn kém để bạn tự quyết có đổi hay không.",
      "minCost": "Chi phí thấp nhất",
      "maxCost": "Chi phí cao nhất",
      "spread": "Chênh lệch",
      "costHidden": "Tài khoản của bạn không được xem số tiền. Nhóm này bị đánh dấu vì giá giữa các vendor chênh nhau nhiều.",
      "undeclaredCount": "{{count}} vendor chưa khai báo chi phí",
      "empty": "Không nhóm split nào có chênh lệch chi phí đáng lưu ý."
    },
    "enable": {
      "heading": "Cách bật hàng rào",
      "alreadyEnforcing": "Hàng rào đang áp dụng. Không cần đổi gì ở đây."
    },
    "enableSteps": {
      "1": "Đặt {{envVar}} thành {{targetMode}} trong biến môi trường của cả hai service.",
      "2": "Khởi động lại {{first}} trước — worker phải áp dụng xong rồi mới có gì báo là đã áp dụng.",
      "3": "Sau đó khởi động lại {{second}}.",
      "4": "Quay lại báo cáo này và kiểm tra banner chế độ đã hiển thị {{targetMode}}."
    },
    "completeness": {
      "unrepresentable": "{{count}} lượt gán khớp một luật nhưng không hiển thị được: chúng được tạo trước khi dữ liệu của báo cáo này tồn tại và không mang tham chiếu variant. Danh sách này không bao phủ chúng — danh sách rỗng ở đây không chứng minh là không có rủi ro.",
      "scanLimitReached": "Chỉ {{limit}} lượt gán đang mở mới nhất được xét. Luật viết hôm nay lại lộ ra những lượt gán cũ hơn, nên phần ngoài cửa sổ đó không được tính ở đây.",
      "truncated": "Đang hiện {{returned}} trên {{matched}}. Phần còn lại bị cắt bởi trần trang, không phải đã xử lý xong."
    }
  },
  "reasons": {
    "NO_VENDOR_MATCH": "Không có vendor nào khớp với item này nên item đang chờ gán tay.",
    "BLOCKED_BY_MERCHANT_RULE": "Luật định tuyến riêng của merchant không chừa lại vendor nào đủ điều kiện nên item đang chờ gán tay.",
    "NO_VENDOR_FOR_LOCATION": "Không vendor nào được ràng buộc với vị trí này cho variant này nên item đang chờ gán tay.",
    "MERCHANT_RULES_UNAVAILABLE": "Không đọc được luật định tuyến của merchant nên item bị giữ lại thay vì định tuyến theo phỏng đoán. Đây là lỗi hệ thống, không phải luật do merchant đặt — hãy kiểm tra service trước khi sửa bất kỳ luật nào.",
    "VENDOR_LOCATION_FROZEN": "Mọi xưởng ở location này đang bị admin đóng băng nên item phải chờ gán tay. Bỏ đóng băng ở tab Locations của xưởng, hoặc gán tay."
  },
  "errors": {
    "ROUTING_WEIGHTS_SUM_INVALID": "Bốn trục phải cộng lại bằng 1. Hãy chỉnh lại rồi gửi.",
    "ROUTING_WEIGHTS_PENDING_EXISTS": "Có đề xuất khác vào chỗ trước. Đề xuất của bạn chưa được gửi — hãy xử lý đề xuất đang chờ rồi thử lại.",
    "ROUTING_WEIGHTS_NO_PENDING": "Không còn đề xuất nào đang chờ — có người đã xử lý trong lúc trang này đang mở.",
    "ROUTING_WEIGHTS_SELF_APPROVAL": "Bạn là người đề xuất bộ này nên không thể tự duyệt. Hãy nhờ một quản trị viên khác.",
    "ROUTING_WEIGHTS_STALE_PROPOSAL": "Đề xuất bạn đang xem không còn là đề xuất đang chờ nữa. Chưa có gì được quyết định — hãy đọc đề xuất hiện tại bên dưới rồi mới thao tác.",
    "ROUTING_WEIGHTS_CANCEL_FORBIDDEN": "Chỉ {{owner}} mới huỷ được đề xuất này. Bạn vẫn có thể duyệt hoặc từ chối.",
    "MERCHANT_ROUTING_RULE_CONFLICT": "Cùng một vendor xuất hiện ở cả danh sách chặn lẫn danh sách cho phép. Chưa lưu gì cả — hãy bỏ vendor đó khỏi một bên.",
    "MERCHANT_ROUTING_RULE_VENDOR_INVALID": "Một trong các id này chưa từng là vendor. Chưa lưu gì cả — hãy bỏ id đó rồi thử lại.",
    "MERCHANT_ROUTING_RULE_VERSION_CONFLICT": "Có người lưu bộ luật này trong lúc bạn đang sửa. Chỉnh sửa của bạn được giữ lại — hãy chọn cách tiếp tục.",
    "MERCHANT_NOT_FOUND": "Merchant đó không còn tồn tại.",
    "ROUTING_PREFERENCE_VERSION_CONFLICT": "Có người lưu thứ tự ưu tiên này trong lúc bạn đang sửa. Chưa ghi gì và chỉnh sửa của bạn được giữ lại — hãy chọn cách tiếp tục.",
    "ROUTING_PREFERENCE_VENDOR_INVALID": "Một trong các id này chưa từng là vendor. Chưa lưu gì cả — hãy bỏ id đó rồi thử lại.",
    "BLUEPRINT_NOT_FOUND": "Blueprint đó không còn tồn tại.",
    "ALLOCATION_VENDOR_NOT_IN_LOCATION_BINDING": "Split này đẩy việc sang vendor mà ràng buộc vị trí không bao gồm. Chưa lưu gì cả — hãy sửa phân bổ, hoặc mở rộng ràng buộc trước.",
    "MERCHANT_RULES_UNAVAILABLE": "Không đọc được luật định tuyến của merchant. Đây là lỗi hệ thống chứ không phải luật — không cần sửa gì trong bộ luật.",
    "VALIDATION_FAILED": "Một số trường chưa hợp lệ. Hãy xem lại các trường được đánh dấu rồi thử lại.",
    "UNAUTHENTICATED": "Vui lòng đăng nhập để tiếp tục.",
    "FORBIDDEN": "Bạn không có quyền thực hiện thao tác này.",
    "INTERNAL_ERROR": "Có lỗi phía hệ thống. Vui lòng thử lại.",
    "NETWORK": "Không kết nối được tới máy chủ — hãy kiểm tra đường truyền rồi thử lại.",
    "GENERIC": "Đã có lỗi xảy ra. Vui lòng thử lại."
  }
}
